import React, { useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { toast } from "react-toastify";

import ViewGasSafeCard from "./ViewGasSafeCard";
import UpdateGasSafeCard from "./UpdateGasSafeCard";
import { updateGasSafeCard, updateStandardDocument, getExpiryFieldName } from "../../api/engineerApi";
import * as engineerApi from "../../api/engineerApi";
import ViewStandardDocument from "./ViewStandardDocument";
import UpdateStandardDocument from "./UpdateStandardDocument";

const GAS_SAFE_CARD = "gasSafeCard";
const CCN1_DOCUMENT = "CCN1Document";
const FLUE_GAS_ANALYSER = "flueGasAnalyserCertificate";
const INSURANCE_DOCUMENT = "insuranceDocument";
const DBS_CERTIFICATE = "dbsCertificate";

// eslint-disable-next-line no-unused-vars
function Documents({ profile, auth, loadProfile }) {
  moment.locale("en");

  const [updatingGasCard, setUpdatingGasCard] = useState(false);
  const [updatingCCN1, setUpdatingCCN1] = useState(false);
  const [updatingFlueGasAnalyserCert, setUpdatingFlueGasAnalyserCert] = useState(false);
  const [updatingInsurance, setUpdatingInsurance] = useState(false);
  const [updatingDbs, setUpdatingDbs] = useState(false);

  const [gasSafeCardFrontImage, setGasSafeCardFrontImage] = useState(null);
  const [gasSafeCardRearImage, setGasSafeCardRearImage] = useState(null);
  const [gasSafeCardExpiry, setGasSafeCardExpiry] = useState(null);
  const [CCN1Document, setCCN1Document] = useState(null);
  const [CCN1Expiry, setCCN1Expiry] = useState(null);
  const [flueGasAnalyserCert, setFlueGasAnalyserCert] = useState(null);
  const [flueGasAnalyserExpiry, setFlueGasAnalyserExpiry] = useState(null);
  const [insuranceDocument, setInsuranceDocument] = useState(null);
  const [insuranceExpiry, setInsuranceExpiry] = useState(null);
  const [dbsCert, setDbsCert] = useState(null);
  const [dbsIssued, setDbsIssued] = useState(null);

  const [formError, setFormError] = useState(false);

  const uploadGasSafeCardFrontToClient = (event) => {
    event.preventDefault();
    if (event.target.files && event.target.files[0]) setGasSafeCardFrontImage(event.target.files[0]);
  };

  const uploadGasSafeCardRearToClient = (event) => {
    event.preventDefault();
    if (event.target.files && event.target.files[0]) setGasSafeCardRearImage(event.target.files[0]);
  };

  const handleGasSafeCardExpiry = (event) => { event.preventDefault(); setGasSafeCardExpiry(event.target.value); };
  const uploadCCN1ToClient = (event) => { event.preventDefault(); if (event.target.files && event.target.files[0]) setCCN1Document(event.target.files[0]); };
  const handleCCN1Expiry = (event) => { event.preventDefault(); setCCN1Expiry(event.target.value); };
  const uploadFlueGasAnalyserCertToClient = (event) => { event.preventDefault(); if (event.target.files && event.target.files[0]) setFlueGasAnalyserCert(event.target.files[0]); };
  const handleFlueGasAnalyserCertExpiry = (event) => { event.preventDefault(); setFlueGasAnalyserExpiry(event.target.value); };
  const uploadInsuranceDocToClient = (event) => { event.preventDefault(); if (event.target.files && event.target.files[0]) setInsuranceDocument(event.target.files[0]); };
  const handleInsuranceExpiry = (event) => { event.preventDefault(); setInsuranceExpiry(event.target.value); };
  const uploadDbsCertToClient = (event) => { event.preventDefault(); if (event.target.files && event.target.files[0]) setDbsCert(event.target.files[0]); };
  const handleDbsIssued = (event) => { event.preventDefault(); setDbsIssued(event.target.value); };

  const updateClickHandler = (event) => {
    event.preventDefault();
    switch (event.target.value) {
      case GAS_SAFE_CARD: setUpdatingGasCard(true); break;
      case CCN1_DOCUMENT: setUpdatingCCN1(true); break;
      case FLUE_GAS_ANALYSER: setUpdatingFlueGasAnalyserCert(true); break;
      case INSURANCE_DOCUMENT: setUpdatingInsurance(true); break;
      case DBS_CERTIFICATE: setUpdatingDbs(true); break;
    }
  };

  const saveClickHandler = async (event) => {
    event.preventDefault();
    try {
      await saveDocument(event.target.value);
    } catch (error) {
      console.log(error);
      toast.error("Failed to save document - please contact us if this error continues");
    }
  };

  const saveDocument = async (documentType) => {
    switch (documentType) {
      case GAS_SAFE_CARD:
        if (gasSafeCardExpiry === null || gasSafeCardFrontImage === null || gasSafeCardRearImage === null) { setFormError(true); }
        else { await updateGasSafeCard(auth, gasSafeCardFrontImage, gasSafeCardRearImage, gasSafeCardExpiry); await loadProfile(auth); setUpdatingGasCard(false); }
        break;
      case CCN1_DOCUMENT:
        if (CCN1Document === null || CCN1Expiry === null) { setFormError(true); }
        else { await updateStandardDocument(auth, CCN1Document, CCN1Expiry, engineerApi.CCN1); await loadProfile(auth); setUpdatingCCN1(false); }
        break;
      case FLUE_GAS_ANALYSER:
        if (flueGasAnalyserCert === null || flueGasAnalyserExpiry === null) { setFormError(true); }
        else { await updateStandardDocument(auth, flueGasAnalyserCert, flueGasAnalyserExpiry, engineerApi.FLUE_GAS_ANALYSER_CERTIFICATE); await loadProfile(auth); setUpdatingFlueGasAnalyserCert(false); }
        break;
      case INSURANCE_DOCUMENT:
        if (insuranceDocument === null || insuranceExpiry === null) { setFormError(true); }
        else { await updateStandardDocument(auth, insuranceDocument, insuranceExpiry, engineerApi.INSURANCE); await loadProfile(auth); setUpdatingInsurance(false); }
        break;
      case DBS_CERTIFICATE:
        if (dbsCert === null || dbsIssued === null) { setFormError(true); }
        else { await updateStandardDocument(auth, dbsCert, dbsIssued, engineerApi.DBS_CERTIFICATE); await loadProfile(auth); setUpdatingDbs(false); }
        break;
    }
  };

  const cancelClickHandler = (event) => {
    event.preventDefault();
    setFormError(false);
    switch (event.target.value) {
      case GAS_SAFE_CARD: setUpdatingGasCard(false); setGasSafeCardExpiry(null); setGasSafeCardFrontImage(null); setGasSafeCardRearImage(null); break;
      case CCN1_DOCUMENT: setUpdatingCCN1(false); setCCN1Document(null); setCCN1Expiry(null); break;
      case FLUE_GAS_ANALYSER: setUpdatingFlueGasAnalyserCert(false); setFlueGasAnalyserCert(null); setFlueGasAnalyserExpiry(null); break;
      case INSURANCE_DOCUMENT: setUpdatingInsurance(false); setInsuranceDocument(null); setInsuranceExpiry(null); break;
      case DBS_CERTIFICATE: setUpdatingDbs(false); setDbsCert(null); setDbsIssued(null); break;
    }
  };

  const CardHeader = ({ title, dateLabel, dateValue, docKey, updating }) => (
    <div className="card-header">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <span className="fw-semibold" style={{ fontSize: "0.9rem" }}>{title}</span>
          <div className="text-muted" style={{ fontSize: "0.78rem" }}>
            {dateLabel}: <span className="fw-medium">{moment(dateValue).format("MMM Do YYYY")}</span>
          </div>
        </div>
        {updating ? (
          <div className="d-flex gap-2 flex-shrink-0 ms-2">
            <button className="btn btn-success btn-sm" value={docKey} onClick={saveClickHandler}>Save</button>
            <button className="btn btn-outline-danger btn-sm" value={docKey} onClick={cancelClickHandler}>Cancel</button>
          </div>
        ) : (
          <button className="btn btn-outline-secondary btn-sm flex-shrink-0 ms-2" value={docKey} onClick={updateClickHandler}>
            Update
          </button>
        )}
      </div>
    </div>
  );

  CardHeader.propTypes = {
    title: PropTypes.string.isRequired,
    dateLabel: PropTypes.string.isRequired,
    dateValue: PropTypes.any,
    docKey: PropTypes.string.isRequired,
    updating: PropTypes.bool.isRequired,
  };

  return (
    <div className="row">
      <div className="col-md-12">

        <div id="gasSafeCard" className="card mb-4">
          <CardHeader
            title="Gas Safe Card"
            dateLabel="Expiry"
            dateValue={profile[getExpiryFieldName(engineerApi.GAS_SAFE_CARD_FRONT)]}
            docKey={GAS_SAFE_CARD}
            updating={updatingGasCard}
          />
          <div className="card-body">
            {updatingGasCard ? (
              <UpdateGasSafeCard
                uploadCardFrontToClientFunc={uploadGasSafeCardFrontToClient}
                uploadCardRearToClientFunc={uploadGasSafeCardRearToClient}
                inputCardExpiryFunc={handleGasSafeCardExpiry}
                formError={formError}
              />
            ) : (
              <ViewGasSafeCard userProfile={profile} />
            )}
          </div>
        </div>

        <div id="ccn1" className="card mb-4">
          <CardHeader
            title="CCN1 Document"
            dateLabel="Expiry"
            dateValue={profile[getExpiryFieldName(engineerApi.CCN1)]}
            docKey={CCN1_DOCUMENT}
            updating={updatingCCN1}
          />
          <div className="card-body">
            {updatingCCN1 ? (
              <UpdateStandardDocument
                documentName={engineerApi.CCN1}
                uploadDocToClientFunc={uploadCCN1ToClient}
                handleDocExpiryFunc={handleCCN1Expiry}
                formError={formError}
              />
            ) : (
              <ViewStandardDocument userProfile={profile} documentType={engineerApi.CCN1} />
            )}
          </div>
        </div>

        <div id="flueGasAnalyser" className="card mb-4">
          <CardHeader
            title="Flue Gas Analyser Certificate"
            dateLabel="Expiry"
            dateValue={profile[getExpiryFieldName(engineerApi.FLUE_GAS_ANALYSER_CERTIFICATE)]}
            docKey={FLUE_GAS_ANALYSER}
            updating={updatingFlueGasAnalyserCert}
          />
          <div className="card-body">
            {updatingFlueGasAnalyserCert ? (
              <UpdateStandardDocument
                documentName={engineerApi.FLUE_GAS_ANALYSER_CERTIFICATE}
                uploadDocToClientFunc={uploadFlueGasAnalyserCertToClient}
                handleDocExpiryFunc={handleFlueGasAnalyserCertExpiry}
                formError={formError}
              />
            ) : (
              <ViewStandardDocument userProfile={profile} documentType={engineerApi.FLUE_GAS_ANALYSER_CERTIFICATE} />
            )}
          </div>
        </div>

        <div id="insuranceDoc" className="card mb-4">
          <CardHeader
            title="Public Liability Insurance"
            dateLabel="Expiry"
            dateValue={profile[getExpiryFieldName(engineerApi.INSURANCE)]}
            docKey={INSURANCE_DOCUMENT}
            updating={updatingInsurance}
          />
          <div className="card-body">
            {updatingInsurance ? (
              <UpdateStandardDocument
                documentName={engineerApi.INSURANCE}
                uploadDocToClientFunc={uploadInsuranceDocToClient}
                handleDocExpiryFunc={handleInsuranceExpiry}
                formError={formError}
              />
            ) : (
              <ViewStandardDocument userProfile={profile} documentType={engineerApi.INSURANCE} />
            )}
          </div>
        </div>

        <div id="dbsCertificate" className="card mb-4">
          <CardHeader
            title="DBS Certificate"
            dateLabel="Issued"
            dateValue={profile[getExpiryFieldName(engineerApi.DBS_CERTIFICATE)]}
            docKey={DBS_CERTIFICATE}
            updating={updatingDbs}
          />
          <div className="card-body">
            {updatingDbs ? (
              <UpdateStandardDocument
                documentName={engineerApi.DBS_CERTIFICATE}
                uploadDocToClientFunc={uploadDbsCertToClient}
                handleDocExpiryFunc={handleDbsIssued}
                formError={formError}
                issuedDate={true}
              />
            ) : (
              <ViewStandardDocument userProfile={profile} documentType={engineerApi.DBS_CERTIFICATE} />
            )}
          </div>
        </div>

      </div>
    </div>
  );
}

Documents.propTypes = {
  profile: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  loadProfile: PropTypes.func.isRequired,
};

export default Documents;
